// extracted by mini-css-extract-plugin
export default {"date":"ChatTextDate_date__U+QDx"};